import { render, staticRenderFns } from "./SectionKamItemProofs.vue?vue&type=template&id=34b55620&"
import script from "./SectionKamItemProofs.vue?vue&type=script&lang=js&"
export * from "./SectionKamItemProofs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports